import {
  SET_INVOICE_LINE_FILTER_VALUE,
  EXPAND_INVOICE_LINE_FILTER,
  APPLY_INVOICE_LINE_FILTERS,
  RESTORE_INVOICE_LINE_FILTERS,
  CLEAR_ALL_INVOICE_LINE_FILTERS,
  CLEAR_INVOICE_LINE_FILTER
} from './InvoiceLinesFiltersConstants';
import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';

const initialFiltersState = [
  {
    title: 'Line Number',
    collapsed: true,
    data: {
      key: 'lineNumber',
      value: null,
      type: STRING
    }
  },
  {
    title: 'Gross Amount',
    collapsed: true,
    data: {
      type: NUMBER,
      min: {
        key: 'grossAmountMin',
        value: null
      },
      max: {
        key: 'grossAmountMax',
        value: null
      }
    }
  },
  {
    title: 'Vendor Tax',
    collapsed: true,
    data: {
      type: NUMBER,
      min: {
        key: 'vendorTaxMin',
        value: null,
        allowNegative: true
      },
      max: {
        key: 'vendorTaxMax',
        value: null,
        allowNegative: true
      }
    }
  },
  {
    title: 'Sovos Tax',
    collapsed: true,
    data: {
      type: NUMBER,
      min: {
        key: 'sovosTaxMin',
        value: null,
        allowNegative: true
      },
      max: {
        key: 'sovosTaxMax',
        value: null,
        allowNegative: true
      }
    }
  },
  {
    title: '$ Variance',
    collapsed: true,
    data: {
      type: NUMBER,
      min: {
        key: 'dollarVarianceMin',
        value: null,
        allowNegative: true
      },
      max: {
        key: 'dollarVarianceMax',
        value: null,
        allowNegative: true
      }
    }
  },
  {
    title: '% Variance',
    collapsed: true,
    data: {
      type: NUMBER,
      min: {
        key: 'percentVarianceMin',
        value: null,
        allowNegative: true
      },
      max: {
        key: 'percentVarianceMax',
        value: null,
        allowNegative: true
      }
    }
  },
];

const checkAppliedFilterFlag = (filters) => {
  let flag = false;
  filters.map(invFilter => {
    if ((invFilter.data.type === STRING || invFilter.data.type === DATE) && invFilter.data.value) {
      flag = true;
    }
    if (invFilter.data.type === NUMBER) {
      if (invFilter.data.min.value) {
        flag = true;
      }
      if (invFilter.data.max.value) {
        flag = true;
      }
    }
  });
  return flag;
};

const initialState = {
  appliedFilters: initialFiltersState,
  tempFilters: initialFiltersState,
  appliedFiltersFlag: false
};

const InvoiceLinesFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPAND_INVOICE_LINE_FILTER:
      return {
        ...state,
        tempFilters: state.tempFilters.map( invFilter => {
          if (invFilter.title === action.filter.title) {
            return { ...invFilter, collapsed: false };
          }
          return { ...invFilter };
        })
      };
    case CLEAR_INVOICE_LINE_FILTER:
      return {
        ...state,
        tempFilters: state.tempFilters.map(invFilter => {
          if (action.filter.data.type === STRING || action.filter.data.type === DATE) {
            if (invFilter.data.key === action.filter.data.key) {
              return {
                ...invFilter,
                data: { ...invFilter.data, value: null },
                collapsed: true
              };
            }
          }
          if (action.filter.data.type === NUMBER && invFilter.data.type === NUMBER) {
            if ((invFilter.data.max.key === action.filter.data.max.key) || (invFilter.data.min.key === action.filter.data.min.key)) {
              return {
                ...invFilter,
                data: {
                  ...invFilter.data,
                  max: { ...invFilter.data.max, value: null },
                  min: { ...invFilter.data.min, value: null }
                },
                collapsed: true
              };
            }
          }
          return { ...invFilter };
        })
      };
    case RESTORE_INVOICE_LINE_FILTERS:
      return { ...state, tempFilters: [...state.appliedFilters] };
    case APPLY_INVOICE_LINE_FILTERS:
      return {
        ...state,
        appliedFilters: [...state.tempFilters],
        appliedFiltersFlag: checkAppliedFilterFlag(state.tempFilters)
      };
    case CLEAR_ALL_INVOICE_LINE_FILTERS:
      return {
        ...state,
        tempFilters: [...initialFiltersState],
        appliedFilters: [...initialFiltersState],
        appliedFiltersFlag: false
      };
    case SET_INVOICE_LINE_FILTER_VALUE:
      return {
        ...state,
        tempFilters: state.tempFilters.map(invFilter => {
          if (action.filterType === STRING || action.filterType === DATE) {
            if (invFilter.data.key === action.filterKey) {
              return {
                ...invFilter,
                data: { ...invFilter.data, value: action.value }
              };
            }
          }
          if (action.filterType === NUMBER && invFilter.data.type === NUMBER) {
            if (invFilter.data.min.key === action.filterKey) {
              return {
                ...invFilter,
                data: {
                  ...invFilter.data,
                  min: { ...invFilter.data.min, value: action.value }
                }
              };
            }

            if (invFilter.data.max.key === action.filterKey) {
              return {
                ...invFilter,
                data: {
                  ...invFilter.data,
                  max: { ...invFilter.data.max, value: action.value }
                }
              };
            }
          }
          return { ...invFilter };
        })
      };
    default:
      return state;
  }
};

export default InvoiceLinesFiltersReducer;


// WEBPACK FOOTER //
// ./src/redux/invoiceLinesFilters/InvoiceLinesFiltersReducer.js